import { Box, Paper, Slider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface FillOpacityControlProps {
  opacity: number;
  onOpacityChange: (value: number) => void;
  popupAbove: boolean;
}

export default function FillOpacityControl({
  opacity,
  onOpacityChange,
  popupAbove,
}: FillOpacityControlProps) {
  const { t } = useTranslation(["bugherd"]);
  const percentage = Math.round(opacity * 100);

  return (
    <Paper
      elevation={4}
      sx={{
        position: "absolute",
        ...(popupAbove ? { bottom: "100%", mb: 1 } : { top: "100%", mt: 1 }),
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        p: 1.5,
        borderRadius: "12px",
        backgroundColor: "#fff",
        zIndex: 10,
        minWidth: 160,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {t("opacity", "Opacity")}: {percentage}%
      </Typography>
      <Box sx={{ width: "90%" }}>
        <Slider
          value={percentage}
          onChange={(_, value) => onOpacityChange((value as number) / 100)}
          min={0}
          max={100}
          size="small"
          sx={{ color: "#7C4DFF" }}
        />
      </Box>
    </Paper>
  );
}
